import { CookieSetOptions } from "universal-cookie";
import { CitySearchResultWithCateg } from "../custom-types/location-search";

export const IMG_BASE_URL = "https://d1rgemtytdlz2g.cloudfront.net";
export const IMG_BASE_URL_NEXTJS = "https://d3ib4ot6oar1ep.cloudfront.net";

export const SOURCE_UTM = "source_custom_utm";
export const PRODUCTION_ENV = "production";

export const IP_DATA_KEY = "f2f334b89f92f60f47e0198355537a6eeee9012ea4106a9729bbb58f";

export const SESSION = {
    shouldPreventLayoutSwitch: "swl"
};

export const COOKIES = {
    token: "vt",
    isVerified: "vv",
    isEmailVerified: "ev",
    isRecoveryEmailVerified: "rev",
    customerCompanyId: "ccid",
    customerPhone: "cpn",
    customerName: "cname",
    customerCompanyLocation: "ccloc",
    csDashboardUserRoles: "csdsbUserRoles",
    csDashboardPermission: "csdsbPerm",
    phoneNum: "phoneNum",
    companyId: "ci",
    companyName: "name",
    companyLocation: "cloc",
    kycPopupInitialLoad: "kip",
    historyLocation: "hl",
    companyLogo: "cLogo",
    userId: "ui",
    serviceType: "st",
    recentTransporterCitySearches: "rtcs",
    currentLoc: "loc",
    callbackRequestedTimestamp: "cr",
    aadharVerificationAttempts: "av",
    blockAadharVerification: "ba",
    blockGstVerification: "bg",
    customerServiceType: "cst",
    fromFlutterApp: "fromFlutterApp",
    citySearchCount: "ctCtySch",
    transporterSearchCount: "ctTspSch",
    abTest: "abt",
    exitIntPopup: "exp",
    wrongTurnPop: "wtp",
    referralCode: "rfc",
    sessionId: "sid",
    vahakAutomation: "va",
    thirdPartyCompanyName: "tpc",
    newUser: "newUser"
};

export const LOC_STORAGE = {
    callbackRequestedTimestamp: "cr",
    requestedTicketTimestamp: "req-tkt",
    clickToCallMpcMode: "ctc-mpc"
};

export const DefaultCookieOptions: CookieSetOptions = {
    path: "/",
    secure: process.env.REACT_APP_ENV === "production" || process.env.NEXT_PUBLIC_REACT_APP_ENV === "production",
    sameSite: "strict",
    maxAge: 24 * 60 * 60 * 30
};

export const CUSTOM_EVENTS = {
    LOGGEDIN: "registered user or logged in user"
};

export const PopularDest: CitySearchResultWithCateg[] = [
    { state_id: 1, state: "Maharashtra" },
    { state_id: 4, state: "Gujarat" },
    { state_id: 2, state: "Delhi" },
    { state_id: 3, state: "Karnataka" }
];
export enum BadgeTypes {
    DEFAULT,
    WARNING,
    ACTIVE,
    PROGRESS,
    COMPLETED,
    PUBLISHED
}

export enum ComponentState {
    NORMAL,
    LOADING
}

export const DEFAULT_COMPANY_LOGO = "default.png";

export const HEADER_ITEM_ATTRIBUTE = "header-item-attribute";
export enum HeaderItemsConstants {
    SERVICE_MENU = "service-menu",
    MARKETPLACE = "marketplace",
    TRANSPORT_DIRECTORY = "transport-directory",
    RESOURCES_MENU = "resources",
    COMPANY_MENU = "company",
    LOGIN = "login",
    MEMBERSHIP = "membership"
}

export const FOOTER_ITEM_ATTRIBUTE = "footer-item-attribute";
export enum FooterItemsConstant {
    ABOUT_US = "about-us",
    CONTACT_US = "contact-us",
    CAREERS = "careers",
    NEWSLETTER = "newsletter",
    CONNECT_WITH_US = "connect-with-us",
    DOWNLOAD_OUR_APP = "download-our-app",
    FAQ = "faq",
    TERMS_AND_CONDITION = "terms-and-condition",
    PAYMENT_GUIDELINES = "payment-guidelines",
    CASHBACK_TERMS_AND_CONDITIONS = "cashback-terms-and-conditions",
    MEDIBUDDY_TERMS_AND_CONDITIONS = "medibuddy-terms-and-conditions",
    TAP_N_GO_TERMS_AND_CONDITIONS = "tap-n-go-terms-and-conditions",
    BUSINESS_LOANS_TERMS_AND_CONDITIONS = "business-loans-terms-and-conditions",
    CI_TERMS_AND_CONDITIONS = "ci-terms-and-conditions",
    GPS_TERMS_AND_CONDITIONS = "gps-terms-and-conditions",
    PRIVACY_POLICY = "privacy-policy",
    NEWSLETTER_SUBSCRIBED = "newsletter-subscribed"
}
export const FB_PIXEL_ID = "466348821937832";

export const FB_CAPI_TOKEN =
    "EAAFGkspC5FIBR8AuEtpezYbxjDHL1YfF6KfjoRlchYKVC2cr5min1ZAZC0Aj6C4AswZCYNRSmfQdbLO92lZBkUfSc4lOqcGbA5Hqo9UnMPznWHpePl5S3P55q0kvtmXCPiFkuKhW7zv2gDwoFLdIQZBdGqPjxt7V7h3o03u8utWdwjMZBcJIj5xU29JBMW4wZDZD";

export const MEMBERSHIP_FEATURE = "https://www.youtube.com/embed/Cc_T6ym0zEQ?si=ETYCxekk991-Zd-c";
export const APP_LINK = "https://app.vahak.in/46EB9yJRwkb";

export const BID_HISTORY_STATUS_MAP: any = {
    0: "Waiting",
    1: "Rejected",
    2: "Approved",
    3: "Completed",
    4: "In Transit"
};
export const CASHFREE_PAYMENT_SUCCESS_STATUS = ["PAID", "TO_SETTLE", "CFLINK_SUCCESS"];

export const WHATSAPP_CHAT = "https://chat.whatsapp.com/HNbwsUwyircDXIBsqk5jus";
export const VAHAK_EMAIL = "cs@vahak.in";
export const VAHAK_EMAIL_INFO = "info@vahak.in";
export const VAHAK_PHONE = "+918035738071";

export const REF_VIEWPORT_HEIGHT = 812;
export const REF_VIEWPORT_WIDTH = 375;

export enum FONT_WEIGHTS {
    extraBold = 1000,
    bold = 850,
    semiBold = 600,
    medium = 550,
    normal = 400
}

export const CACHE_NAME = "v-cache";

export const EXPIRED_LORRY_STATUS = [0, 4];

export const USER_PROFILE_MODAL_TITLE: any = {
    "company-details": "ABOUT COMPANY",
    "my-routes": "MY ROUTES",
    "my-lorries": "MY LORRIES",
    "office-address": "OFFICE ADDRESSES",
    "document-verification": "Document Verification",
    "company-bio": "Company Bio",
    reviews: "My Reviews",
    faqs: "FAQS",
    aadharVerification: "Aadhaar Verification",
    gstVerification: "Business Document Verification"
};

export const CITIES_WITH_CITY_PAGES = [
    "mumbai",
    "delhi",
    "bangalore",
    "kolkata",
    "chennai",
    "hyderabad",
    "ahmedabad",
    "jaipur",
    "pune"
];
